<template>
  <div class="md-layout md-alignment-center-center gray-6 bg new-globals">
    <license-form />
  </div>
</template>

<script>
import LicenseForm from '../../components/auth/LicenseForm';

export default {
  name: 'license',
  components: {
    LicenseForm,
  },
};
</script>

<style>
</style>
